<ng-container [ngSwitch]="template">
  <div class="{{ classes }}" *transloco="let t">

    <ng-container *ngSwitchCase="'taxpayer'">
        <span>{{ data[0] }}</span>
        <br>
        <span class="text-sm text-grey-medium">{{ data[1] }}</span>
    </ng-container>

    <ng-container *ngSwitchCase="'date'">
        <span class="whitespace-nowrap" title="{{ data | date: dateFormatDataTableTime }}">
          {{ data | date: dateFormatDataTable }}
        </span>
    </ng-container>

    <ng-container *ngSwitchCase="'invoiceStatus'">
      <span attr.data-status="{{ data | invoiceStatus }}">
        {{ data | invoiceStatus }}
      </span>
    </ng-container>

    <ng-container *ngSwitchCase="'runtimeStatus'">
      <span attr.data-runlog-status="{{ data | runtimeStatus }}">
        {{ data | runtimeStatus }}
      </span>
    </ng-container>

    <ng-container *ngSwitchCase="'invoiceAppearance'">
      {{ data | invoiceAppearance }}
    </ng-container>

    <ng-container *ngSwitchCase="'invoiceCategory'">
      {{ data | invoiceCategory }}
    </ng-container>

    <ng-container *ngSwitchCase="'decimal'">
      {{ data | number: '1.2-6' : t('lang') }}
    </ng-container>

    <ng-container *ngSwitchCase="'boolean'">
      <!-- <span class="{{ (data | case: 'lowerFirst') === 'true' ? 'icon-circleCheckmark-fill' : 'icon-circleDelete-fill'}}"></span> -->
      {{ ((data | case: 'lowerFirst') === 'true' ? t('yes') : t('no')) | case: 'lower' }}
    </ng-container>

    <ng-container *ngSwitchCase="'toggle'">
      <p-toggleswitch [ngModel]="(data | case: 'lowerFirst') === 'true'" [disabled]="true" styleClass="{{ classes }}"></p-toggleswitch>
    </ng-container>

    <ng-container *ngSwitchCase="'unitOfMeasure'">
      {{ data[0] }}
      <ng-container *ngIf="data[1]">
        <br>
        ({{ data[1] }})
      </ng-container>
    </ng-container>

    <ng-container *ngSwitchCase="'conventionalInfos'">
      <ng-container *ngIf="data?.length">
        <div *ngFor="let conventionalInfo of data" class="conventionalinfo-card" title="{{ conventionalInfo.description }}">
          <span class="block text-[12px] text-grey-default leading-tight">{{ conventionalInfo.conventionalInfoKey.keyName }}</span>
          <span class="text-[14px] block">
            <ng-container *ngVar="(conventionalInfo.conventionalInfoKey.dataType | conventionalInfoDataType) as dataType" [ngSwitch]="dataType">
              <render-value *ngSwitchCase="'DateTime'" data="{{ conventionalInfo.value }}" template="date"></render-value>
              <render-value *ngSwitchCase="'Numeric'" data="{{ toDecimal(conventionalInfo.value) }}" template="decimal" classes="text-left"></render-value>
              <render-value *ngSwitchCase="'Boolean'" data="{{ conventionalInfo.value }}" template="toggle" classes="p-toggleswitch-sm relative top-1px"></render-value>
              <render-value *ngSwitchDefault data="{{ conventionalInfo.value }}"></render-value>
            </ng-container>
          </span>
        </div>
      </ng-container>
    </ng-container>

    <ng-container *ngSwitchDefault>
      {{ data }}
    </ng-container>

  </div>
</ng-container>